import { readonly, ref, watchEffect } from "vue";

import { useTrialCountdown } from "@/lib/composable/freeTrail/useTrialCountdown";

import type {
  TrialResult,
} from "@/lib/utils/free_trials";

const sharedTrialDays = ref<TrialResult>(false);

let initialized = false;

export function useGlobalTrialState(
  trialData: any,
  userStore: any,
  options?: {
    navigateToBilling?: () => void;
    setIsTrailAccount?: (value: boolean) => void;
    setIsTrialExpired?: (value: boolean) => void;
  }
) {
  /**
   * Shared updater
   */
  const updateState = (trialDaysValue: TrialResult) => {
    sharedTrialDays.value = trialDaysValue;

    if (trialDaysValue) {
      options?.setIsTrailAccount?.(true);

      const days = parseInt(trialDaysValue.maxDays);

      if (days <= 0) {
        options?.setIsTrialExpired?.(true);
       userStore.setSingleProductAccess('marketing', false);
       userStore.setSingleProductAccess('service', false);
        userStore.setSingleProductAccess('commerce', false);
        if(!userStore.getProductAccess('neto') && !userStore.getProductAccess('mhc'))
          options?.navigateToBilling?.();
      } else {
        options?.setIsTrialExpired?.(false);
      }
    } else {
      options?.setIsTrailAccount?.(false);
      options?.setIsTrialExpired?.(false);
    }
  };

  if (!initialized) {
    initialized = true;

    const { trialDays } = useTrialCountdown(
      () => trialData,
      () =>
        new Date(
          trialData?.timestamp || new Date().toISOString()
        ).toISOString()
    );

    /**
     * IMPORTANT:
     * Initial synchronous update
     */

    updateState(trialDays.value);

    /**
     * Reactive updates
     */
    watchEffect(() => {
      updateState(trialDays.value);
    });
  }

  return {
    trialDays: readonly(sharedTrialDays),
  };
}